import { defineStore } from '@sunrise/pinia'

import { SearchBoxDefault } from '../../../components/MsSearchBox/MsSearchBox.enum'

import { SearchBoxPropertyType } from '../../../cmsElements/M/M_RealEstate_SearchList/M_RealEstate_SearchList.enum'

import { SortCriteria } from '../../service/realEstateService.enum'
import { ResultListStore } from './resultListStoreModule.interface'

export const useResultListStore = defineStore('resultList', {
    state: (): ResultListStore => ({
        searchParams: {
            location: undefined,
            lat: undefined,
            lng: undefined,
            page: SearchBoxDefault.PAGE as number,
            pageSize: SearchBoxDefault.PAGE_SIZE as number,
            sr: SearchBoxDefault.SEARCH_RADIUS as string,
            sort: SearchBoxDefault.SELECTED_SORT as string as SortCriteria,
            etype: undefined,
            esr: undefined,
            filterTag: undefined,
            eqid: [],
            furnid: -1,
            epos: [],
            ecat: [],
            primi: undefined,
            prima: undefined,
            flmi: undefined,
            flma: undefined,
            roomi: undefined,
            rooma: undefined,
        },
        searchBoxHeadline: '',
        searchBoxPropertyType: SearchBoxPropertyType.RESIDENTIAL,
        selectedEstateType: '',
        selectedLocation: '',
    }),
    actions: {
        resetPage() {
            this.searchParams.page = SearchBoxDefault.PAGE
        },
        resetFilter() {
            this.searchParams.eqid = []
            this.searchParams.furnid = -1
            this.searchParams.epos = []
            this.searchParams.ecat = []
            this.searchParams.primi = undefined
            this.searchParams.prima = undefined
            this.searchParams.flmi = undefined
            this.searchParams.flma = undefined
            this.searchParams.roomi = undefined
            this.searchParams.rooma = undefined
            this.searchParams.sr = SearchBoxDefault.SEARCH_RADIUS
        },
        updateHeadline(estateType?: string, selectedLocation?: string) {
            if (estateType) {
                this.selectedEstateType = estateType
            }

            if (selectedLocation) {
                this.selectedLocation = selectedLocation
            }

            this.searchBoxHeadline = `${this.selectedEstateType} in ${this.selectedLocation}`
        },
    },
})
